'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GeckoFieldsModel = exports.GeckoFieldModel = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeckoFieldModel = exports.GeckoFieldModel = {
    key: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.oneOf([_constants.GECKO_CONSTS.FIELD_TYPE_ADDRESS, _constants.GECKO_CONSTS.FIELD_TYPE_CHECKBOX, _constants.GECKO_CONSTS.FIELD_TYPE_COLOR, _constants.GECKO_CONSTS.FIELD_TYPE_CUSTOM, _constants.GECKO_CONSTS.FIELD_TYPE_DATE, _constants.GECKO_CONSTS.FIELD_TYPE_DISPLAY, _constants.GECKO_CONSTS.FIELD_TYPE_EMAIL, _constants.GECKO_CONSTS.FIELD_TYPE_NAME, _constants.GECKO_CONSTS.FIELD_TYPE_NUMBER, _constants.GECKO_CONSTS.FIELD_TYPE_PASSWORD, _constants.GECKO_CONSTS.FIELD_TYPE_RADIO, _constants.GECKO_CONSTS.FIELD_TYPE_RICH_TEXT, _constants.GECKO_CONSTS.FIELD_TYPE_SEARCH, _constants.GECKO_CONSTS.FIELD_TYPE_SELECT, _constants.GECKO_CONSTS.FIELD_TYPE_SELECT_CREATE_MULTI, _constants.GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI, _constants.GECKO_CONSTS.FIELD_TYPE_TELEPHONE, _constants.GECKO_CONSTS.FIELD_TYPE_TEXT, _constants.GECKO_CONSTS.FIELD_TYPE_TEXTAREA, _constants.GECKO_CONSTS.FIELD_TYPE_TITLE, _constants.GECKO_CONSTS.FIELD_TYPE_TOGGLE, _constants.GECKO_CONSTS.FIELD_TYPE_URL]),
    label: _propTypes2.default.string,
    class: _propTypes2.default.string,
    width: _propTypes2.default.string,
    //break: PropTypes.bool,
    required: _propTypes2.default.bool,
    requiredWhen: _propTypes2.default.func,
    disabled: _propTypes2.default.bool,
    disabledWhen: _propTypes2.default.func,
    description: _propTypes2.default.string,
    hideWhen: _propTypes2.default.func,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.string,
        value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
        selected: _propTypes2.default.bool
    })),
    optionValueKey: _propTypes2.default.string,
    optionLabelKey: _propTypes2.default.string,
    trueValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
    falseValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
    render: _propTypes2.default.func,
    onChange: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    errors: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.func]),
    config: _propTypes2.default.shape({
        placeholder: _propTypes2.default.string,
        rows: _propTypes2.default.number,
        cols: _propTypes2.default.number
    })
};

var GeckoFieldsModel = exports.GeckoFieldsModel = _propTypes2.default.arrayOf(_propTypes2.default.shape(GeckoFieldModel));